const anchorLink = $('.anchor-links .anchor-links-item');
const framesInfo = $('.product-item-frames-info');

if ( anchorLink.length && framesInfo.length ) {
  setMarginPaddingIfStickyHeader();
  anchorLink.on( 'click', function() {
    setMarginPaddingIfStickyHeader();
  });
}

function setMarginPaddingIfStickyHeader() {
  // check if frames-info is set as anchor link
  if ( anchorLink.attr('href') === '#' + framesInfo.attr('id') ) {
    const sectionHeader = $('.section-header');
    const isStickyHeader = sectionHeader?.css('position') || null;

    // if sticky header is set, set margin and padding to frames-info
    if (isStickyHeader === 'sticky') {
      const stickyHeaderHeight = sectionHeader.height();

      framesInfo.css({
        "padding-top": stickyHeaderHeight + 'px',
        "margin-top": -stickyHeaderHeight + 'px'
      });
    }
  }
}